import React from 'react';
import JobCard from './Job-Card';
import './job-list.css';

const JobList = ({ jobs, appliedJobs, onApplyJob }) => {
    return (
        <div className="job-list">
            {jobs.map((job, index) => (
                <JobCard
                    key={index}
                    job={job}
                    // applied={appliedJobs.includes(job._id)}
                    onApplyJob={onApplyJob}
                />
            ))}
        </div>
    );
};

export default JobList;
